<template>
  <div class="shadow-card rounded-2xl bg-white p-6 md:p-8">
    <div class="relative pb-9 h-[14rem] max-h-[124px] md:h-[14rem] md:max-h-[224px]">
      <div class="relative w-full h-full">
        <img
          class="aspect-auto block w-full h-full object-cover"
          :src="coverImage"
          :alt="__('Company cover image')"
        />

        <div
          class="shadow-card absolute -bottom-9 left-5 h-[4.5rem] w-[4.5rem] rounded bg-white p-1 md:h-[6.25rem] md:w-[6.25rem]"
        >
          <img
            class="rounded-sm object-cover"
            :src="logoImage"
            :alt="__('Company logo image')"
          />
        </div>
      </div>

      <div
        v-if="renderSocialLinks"
        class="absolute bottom-0 right-1 flex gap-2"
      >
        <a
          v-if="data.social_links.facebook"
          class="-m-1 rounded p-2 transition-colors hover:bg-primary/5"
          :href="data.social_links.facebook"
          target="_blank"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              class="fill-primary"
              d="M12.6 4.43344H14.1667V1.78344C13.4082 1.70456 12.646 1.66562 11.8834 1.66677C9.61669 1.66677 8.0667 3.05011 8.0667 5.58344V7.76677H5.50836V10.7334H8.0667V18.3334H11.1334V10.7334H13.6834L14.0667 7.76677H11.1334V5.87511C11.1334 5.00011 11.3667 4.43344 12.6 4.43344Z"
            />
          </svg>
        </a>
        <a
          v-if="data.social_links.instagram"
          class="-m-1 rounded p-2 transition-colors hover:bg-primary/5"
          :href="data.social_links.instagram"
          target="_blank"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              class="fill-primary"
              d="M14.45 4.55008C14.2522 4.55008 14.0589 4.60873 13.8945 4.71861C13.73 4.82849 13.6018 4.98467 13.5261 5.1674C13.4505 5.35012 13.4306 5.55119 13.4692 5.74517C13.5078 5.93915 13.6031 6.11734 13.7429 6.25719C13.8828 6.39704 14.061 6.49228 14.2549 6.53087C14.4489 6.56945 14.65 6.54965 14.8327 6.47396C15.0154 6.39827 15.1716 6.2701 15.2815 6.10565C15.3914 5.9412 15.45 5.74786 15.45 5.55008C15.45 5.28486 15.3447 5.03051 15.1571 4.84297C14.9696 4.65544 14.7152 4.55008 14.45 4.55008ZM18.2834 6.56675C18.2671 5.87533 18.1377 5.19125 17.9 4.54175C17.6881 3.98603 17.3583 3.48281 16.9334 3.06675C16.5207 2.6396 16.0163 2.3119 15.4584 2.10841C14.8106 1.86355 14.1257 1.73109 13.4334 1.71675C12.55 1.66675 12.2667 1.66675 10 1.66675C7.73335 1.66675 7.45002 1.66675 6.56669 1.71675C5.87431 1.73109 5.18947 1.86355 4.54169 2.10841C3.98475 2.31396 3.4808 2.64138 3.06669 3.06675C2.63954 3.4794 2.31183 3.98378 2.10835 4.54175C1.86349 5.18953 1.73103 5.87438 1.71669 6.56675C1.66669 7.45008 1.66669 7.73342 1.66669 10.0001C1.66669 12.2667 1.66669 12.5501 1.71669 13.4334C1.73103 14.1258 1.86349 14.8106 2.10835 15.4584C2.31183 16.0164 2.63954 16.5208 3.06669 16.9334C3.4808 17.3588 3.98475 17.6862 4.54169 17.8917C5.18947 18.1366 5.87431 18.2691 6.56669 18.2834C7.45002 18.3334 7.73335 18.3334 10 18.3334C12.2667 18.3334 12.55 18.3334 13.4334 18.2834C14.1257 18.2691 14.8106 18.1366 15.4584 17.8917C16.0163 17.6883 16.5207 17.3606 16.9334 16.9334C17.3602 16.5189 17.6903 16.0152 17.9 15.4584C18.1377 14.8089 18.2671 14.1248 18.2834 13.4334C18.2834 12.5501 18.3334 12.2667 18.3334 10.0001C18.3334 7.73342 18.3334 7.45008 18.2834 6.56675ZM16.7834 13.3334C16.7773 13.8624 16.6815 14.3865 16.5 14.8834C16.367 15.2461 16.1533 15.5738 15.875 15.8417C15.6047 16.1172 15.2777 16.3304 14.9167 16.4667C14.4198 16.6482 13.8957 16.744 13.3667 16.7501C12.5334 16.7917 12.225 16.8001 10.0334 16.8001C7.84169 16.8001 7.53335 16.8001 6.70002 16.7501C6.15076 16.7604 5.60385 16.6758 5.08335 16.5001C4.73817 16.3568 4.42615 16.1441 4.16669 15.8751C3.89009 15.6074 3.67906 15.2794 3.55002 14.9167C3.34657 14.4127 3.23372 13.8767 3.21669 13.3334C3.21669 12.5001 3.16669 12.1917 3.16669 10.0001C3.16669 7.80841 3.16669 7.50008 3.21669 6.66675C3.22042 6.12596 3.31915 5.59004 3.50835 5.08341C3.65506 4.73167 3.88024 4.41813 4.16669 4.16675C4.41986 3.88022 4.73276 3.65266 5.08335 3.50008C5.59131 3.31678 6.12669 3.22098 6.66669 3.21675C7.50002 3.21675 7.80835 3.16675 10 3.16675C12.1917 3.16675 12.5 3.16675 13.3334 3.21675C13.8623 3.22282 14.3864 3.31862 14.8834 3.50008C15.262 3.64062 15.6019 3.86912 15.875 4.16675C16.1481 4.42273 16.3615 4.73569 16.5 5.08341C16.6852 5.59086 16.7811 6.12656 16.7834 6.66675C16.825 7.50008 16.8334 7.80841 16.8334 10.0001C16.8334 12.1917 16.825 12.5001 16.7834 13.3334ZM10 5.72508C9.15486 5.72673 8.32916 5.97885 7.62723 6.4496C6.92531 6.92034 6.37867 7.58858 6.05638 8.36988C5.7341 9.15117 5.65062 10.0105 5.81652 10.8392C5.98241 11.6679 6.39022 12.4289 6.98842 13.0259C7.58662 13.6229 8.34836 14.0293 9.1774 14.1935C10.0064 14.3578 10.8656 14.2727 11.6462 13.9489C12.4269 13.6251 13.0941 13.0771 13.5635 12.3743C14.0328 11.6714 14.2834 10.8452 14.2834 10.0001C14.2845 9.43767 14.1744 8.88059 13.9594 8.36088C13.7444 7.84117 13.4288 7.36909 13.0307 6.97179C12.6327 6.57449 12.16 6.25981 11.6399 6.04586C11.1197 5.8319 10.5624 5.72288 10 5.72508ZM10 12.7751C9.45118 12.7751 8.91466 12.6123 8.45831 12.3074C8.00197 12.0025 7.64629 11.5691 7.43625 11.062C7.22622 10.555 7.17127 9.997 7.27834 9.45871C7.38542 8.92041 7.64971 8.42595 8.0378 8.03786C8.42589 7.64977 8.92035 7.38548 9.45865 7.2784C9.99694 7.17133 10.5549 7.22628 11.062 7.43632C11.569 7.64635 12.0024 8.00203 12.3073 8.45837C12.6123 8.91472 12.775 9.45124 12.775 10.0001C12.775 10.3645 12.7032 10.7253 12.5638 11.062C12.4243 11.3987 12.2199 11.7046 11.9622 11.9623C11.7046 12.22 11.3986 12.4244 11.062 12.5638C10.7253 12.7033 10.3644 12.7751 10 12.7751Z"
            />
          </svg>
        </a>
        <a
          v-if="data.social_links.linkedin"
          class="-m-1 rounded p-2 transition-colors hover:bg-primary/5"
          :href="data.social_links.linkedin"
          target="_blank"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              class="fill-primary"
              d="M1.66667 2.86042C1.66667 2.20104 2.21458 1.66667 2.89062 1.66667H17.1094C17.7854 1.66667 18.3333 2.20104 18.3333 2.86042V17.1396C18.3333 17.799 17.7854 18.3333 17.1094 18.3333H2.89062C2.21458 18.3333 1.66667 17.799 1.66667 17.1396V2.86042ZM6.81562 15.6187V8.09271H4.31458V15.6187H6.81562ZM5.56563 7.06458C6.4375 7.06458 6.98021 6.4875 6.98021 5.76458C6.96458 5.02604 6.43854 4.46458 5.58229 4.46458C4.72604 4.46458 4.16667 5.02708 4.16667 5.76458C4.16667 6.4875 4.70937 7.06458 5.54896 7.06458H5.56563ZM10.6781 15.6187V11.4156C10.6781 11.1906 10.6948 10.9656 10.7615 10.8052C10.9417 10.3562 11.3531 9.89062 12.0448 9.89062C12.95 9.89062 13.3115 10.5802 13.3115 11.5927V15.6187H15.8125V11.3021C15.8125 8.98958 14.5792 7.91458 12.9333 7.91458C11.6063 7.91458 11.0115 8.64375 10.6781 9.15729V9.18333H10.6615C10.667 9.17464 10.6725 9.16596 10.6781 9.15729V8.09271H8.17812C8.20937 8.79896 8.17812 15.6187 8.17812 15.6187H10.6781Z"
            />
          </svg>
        </a>
        <a
          v-if="data.social_links.twitter"
          class="-m-1 rounded p-2 transition-colors hover:bg-primary/5"
          :href="data.social_links.twitter"
          target="_blank"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              class="fill-primary"
              d="M14.8355 2.47324H17.3907L11.7803 8.86127L18.335 17.5268H13.1912L9.16401 12.2608L4.55351 17.5268H1.9983L7.94195 10.6944L1.66501 2.47324H6.93653L10.5749 7.28371L14.8355 2.47324ZM13.9411 16.027H15.3576L6.19218 3.91749H4.67016L13.9411 16.027Z"
            />
          </svg>
        </a>
        <a
          v-if="data.social_links.youtube"
          class="-m-1 rounded p-2 transition-colors hover:bg-primary/5"
          :href="data.social_links.youtube"
          target="_blank"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              class="fill-primary"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M17.1581 15.9425C15.7336 16.3218 9.99037 16.3218 9.99037 16.3218C9.99037 16.3218 4.25998 16.3218 2.84183 15.9425C2.05254 15.7275 1.43651 15.108 1.21192 14.343C0.833313 12.9396 0.833313 9.9873 0.833313 9.9873C0.833313 9.9873 0.833313 7.05396 1.21192 5.66316C1.43651 4.87925 2.05254 4.27235 2.84183 4.06373C4.25998 3.6781 9.99037 3.6781 9.99037 3.6781C9.99037 3.6781 15.7336 3.6781 17.1581 4.06373C17.9602 4.27235 18.5635 4.87925 18.7752 5.66316C19.1666 7.05396 19.1666 9.9873 19.1666 9.9873C19.1666 9.9873 19.1666 12.9396 18.7752 14.343C18.5635 15.108 17.9602 15.7275 17.1581 15.9425ZM8.10343 7.31316L12.8448 9.99994L8.10343 12.6867V7.31316Z"
            />
          </svg>
        </a>
        <a
          v-if="data.social_links.tiktok"
          class="-m-1 rounded p-2 transition-colors hover:bg-primary/5"
          :href="data.social_links.tiktok"
          target="_blank"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              class="fill-primary"
              d="M16.3242 5.57166C15.492 5.39364 14.7383 4.95446 14.1732 4.31813C13.6081 3.68179 13.261 2.88159 13.1825 2.03416V1.66666H10.3117V13.06C10.3099 13.5644 10.1501 14.0556 9.85481 14.4645C9.55949 14.8734 9.14347 15.1795 8.66521 15.3398C8.18696 15.5 7.6705 15.5064 7.18842 15.358C6.70634 15.2097 6.28286 14.914 5.97751 14.5125C5.66741 14.1043 5.49539 13.608 5.4864 13.0954C5.4774 12.5829 5.6319 12.0808 5.92748 11.662C6.22306 11.2432 6.64437 10.9294 7.1303 10.7662C7.61623 10.6029 8.14152 10.5987 8.63001 10.7542V7.8375C7.54072 7.68691 6.4316 7.88057 5.4578 8.39139C4.48399 8.9022 3.69421 9.70462 3.19891 10.6864C2.70361 11.6682 2.52757 12.7802 2.69541 13.867C2.86325 14.9538 3.36659 15.9609 4.13501 16.7475C4.86781 17.4973 5.80741 18.0117 6.83389 18.2251C7.86036 18.4385 8.92714 18.3412 9.89805 17.9455C10.869 17.5499 11.7 16.8739 12.285 16.0039C12.87 15.1339 13.1824 14.1093 13.1825 13.0608V7.23916C14.3427 8.06861 15.7338 8.51337 17.16 8.51083V5.65833C16.8791 5.65868 16.599 5.62963 16.3242 5.57166Z"
            />
          </svg>
        </a>
      </div>
    </div>

    <div class="mt-8 space-y-1">
      <span class="block text-2xl font-medium leading-8 text-primary">
        {{ data.name }}
      </span>
      <span class="block text-lg font-medium text-zinc-800">
        {{ data.short_description }}
      </span>
    </div>

    <div v-if="renderCompanyInformation" class="mt-4 flex flex-wrap gap-4">
      <div
        v-if="data.work_type && data.work_type.length"
        class="flex items-center gap-1.5"
      >
        <Icon
          class="text-2xl text-primary"
          name="work"
          is-filled
          :aria-label="__('Presence')"
        />

        <span class="text-sm text-zinc-800">
          {{ data.work_type.map((type) => type.name).join(', ') }}
        </span>
      </div>
      <div v-if="data.employee_number" class="flex items-center gap-1.5">
        <Icon
          class="text-2xl text-primary"
          name="group"
          is-filled
          :aria-label="__('Employee number')"
        />

        <span class="text-sm text-zinc-800">
          {{ `${data.employee_number.name} ${__('Employees')}` }}
        </span>
      </div>
      <div v-if="data.industry" class="flex items-center gap-1.5">
        <Icon
          class="text-2xl text-primary"
          name="domain"
          :aria-label="__('Industry')"
        />

        <span class="text-sm text-zinc-800">
          {{ data.industry }}
        </span>
      </div>
      <div v-if="data.website" class="flex items-center gap-1.5">
        <Icon
          class="text-2xl text-primary"
          name="language"
          :aria-label="__('Website')"
        />

        <a
          class="text-sm text-zinc-800 underline underline-offset-2"
          :href="data.website"
          target="_blank"
        >
          {{ data.website.replace(/^https?:\/\//, '') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { Icon } from '@/components/block/icon';

  const props = defineProps({
    data: {
      type: Object,
      required: true
    }
  });

  const coverImage = computed(() => {
    return props.data.cover_url
      ? `/uploads/${props.data.cover_url}`
      : '/images/cover_placehsolder.png';
  });

  const logoImage = computed(() => {
    return props.data.logo_url
      ? `/uploads/${props.data.logo_url}`
      : '/images/logo_placeholder.png';
  });

  const renderSocialLinks = computed(() => {
    return (
      props.data.social_links &&
      (props.data.social_links.facebook ||
        props.data.social_links.instagram ||
        props.data.social_links.linkedin ||
        props.data.social_links.twitter ||
        props.data.social_links.youtube ||
        props.data.social_links.tiktok)
    );
  });

  const renderCompanyInformation = computed(() => {
    return (
      (props.data.work_type && props.data.work_type.length) ||
      props.data.employee_number ||
      props.data.industry ||
      props.data.website
    );
  });
</script>
